import { useState } from "react";
import "./styles/cis.css";
import PanelCis from "../components/cis-components/PanelCis";
import PanelPortafolio from "../components/portafolio-components/PanelPortafolio";
import Search from "../components/generales/Search";
import { lang } from "../components/generales/traduction";
import { capitalizeFirstLetter } from "../utils/utils";
import Action from "../components/Action";
import Modal from "react-modal";
import PanelPortafolioTecs from "../components/portafolio-components/PanelPortafolioTecs";
import PanelPortafolioDevices from "../components/portafolio-components/PanelPortafolioDevices";


const Portafolio = ({ server, dataGlobals,languaje,mode ,handleShowPopup}) => {
  const [ServiceSelected, setServiceSelected] = useState([]);
  const [tecSelected,setTecSelected]=useState([])
  const [sla,setSla]=useState(0)
  const [slaService,setSlaService]=useState(0)
  const [slaTech,setSlaTech]=useState(0)

  return (
    <>
    <div className={"main-cis"+mode}>
      
      
        {/* {listSelected === 1 ? */}
        {
          (ServiceSelected.length==0)?<PanelPortafolio server={server} 
          ServiceSelected={ServiceSelected}
          setServiceSelected={setServiceSelected}
          languaje={languaje}
              mode={mode}       
              handleShowPopup={handleShowPopup}   
         /> :((tecSelected.length==0)?<PanelPortafolioTecs 
         server={server}
         ServiceSelected={ServiceSelected}
         setServiceSelected={setServiceSelected}
         tecSelected={tecSelected}
         setTecSelected={setTecSelected}
         languaje={languaje}
         mode={mode}    
         setSla={setSla}
         sla={setSla}
         slaService={slaService}
         setSlaService={setSlaService}
         handleShowPopup={handleShowPopup}
       />:<PanelPortafolioDevices
       server={server}
       ServiceSelected={ServiceSelected}
       setServiceSelected={setServiceSelected}
       tecSelected={tecSelected}
       setTecSelected={setTecSelected}
       slaService={slaService}
         setSlaService={setSlaService}
         slaTech={slaTech}
         setSlaTech={setSlaTech}
       languaje={languaje}
       mode={mode} 
       handleShowPopup={handleShowPopup}   
     />)

        }
         

        
    
    </div>
    
    </>
  );
};

export default Portafolio;
